module.exports = __webpack_public_path__ + "img/qrcode1.4e09a69b.png";